// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2CPhQ","colMaxWidth":"Table_colMaxWidth__lsJ8T"};